// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"86a3d31d","406":"1c45a5d5","453":"a3c1d153","606":"5f713562","633":"e02a5311","950":"24bb6a53"}[chunkId] + ".chunk.js";
};